import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NextPage } from "@cvx/nextpage";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "./material.module";
import { SpinnerComponent } from "./shared/spinner/spinner.component";
import { ActionButtonComponent } from "./shared/action-button/action-button.component";
import { JsonViewDialogComponent } from "./shared/json-view-dialog/json-view-dialog.component";
import { AiResultDrawerComponent } from "./shared/ai-result-drawer/ai-result-drawer.component";

const localComponents = [
  ActionButtonComponent,
  SpinnerComponent,
  JsonViewDialogComponent,
  AiResultDrawerComponent,
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    NextPage,
    ...localComponents,
  ],
  exports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NextPage,
    localComponents,
  ],
})
export class SharedModule {}
